import { generateHotelSearchUrlWithLocation } from '@/urls';
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

interface Props extends Omit<LinkProps, 'to'> {
  locationCode: string;
  locationType: any;
}

export default function HotelLocationSearchLink({ locationCode, locationType, children, ...props }: Props) {
  const url = React.useMemo(() => {
    return generateHotelSearchUrlWithLocation(locationCode, locationType);
  }, [locationCode, locationType]);
  return (
    <Link {...props} to={url}>
      {children}
    </Link>
  );
}
